import { connect } from 'react-redux';

import { AppState } from 'bootstrap.store';
import { PresenceList } from 'components/presence/components/presenceList';

const mapStateToProps = (state: AppState) => ({
  profile: state.settings.profile.profile,
  presence: state.presence,
  favouriteTeamMemberIds: state.settings.personal.favouriteTeamMemberIds,
});

export default connect(mapStateToProps)(PresenceList);
